import React from 'react';
import PropTypes from 'prop-types';

import { Column } from 'components/shared/Layout';
import { ConfirmButton } from 'components/ui/Button';
import { FormattedMessage } from 'react-intl';
import { StyledColumn } from '../AfterSalesWarning.styles';

const RevertChangesWarning = ({ revertChanges, loading }) => (
  <>
    <Column>
      <FormattedMessage id="manageBooking.doYouWishToRevert" />
    </Column>
    <StyledColumn span={3}>
      <ConfirmButton data-cy="revert-changes" onClick={revertChanges} loading={loading}>
        <FormattedMessage id="manageBooking.revertChanges" />
      </ConfirmButton>
    </StyledColumn>
  </>
);

RevertChangesWarning.propTypes = {
  revertChanges: PropTypes.func,
  loading: PropTypes.bool
};

export default RevertChangesWarning;
